export default {
  C: "do",
  CSharp: "do na likoló",
  D: "lé",
  DFlat: "lé na nsé",
  DSharp: "lé na likoló",
  E: "mi",
  EFlat: "mi na nsé",
  F: "fa",
  FSharp: "fa na likoló",
  G: "so",
  GFlat: "so na nsé",
  GSharp: "so na likoló",
  A: "la",
  AFlat: "la na nsé",
  ASharp: "la na likoló",
  B: "si",
  BFlat: "si na nsé",

  correctExcl: "Ezalí malámu!",
  wrongExcl: "Ezalí lokutá!",

  ABORT: "KOSUNDOLA MOBÉMBO",

  lastRound: "Mobémbo mwa súka",
  score: "Mongété",
  accuracy: "Polélé",
  correct: "malámu",
  wrong: "lokutá",

  START: "EBANDI",
  settings: "Mapɔni",
  ROUND_LENGTH: "BOWÚMELI BWA MOBÉMBO",
  NOTE_INPUT: "KOKOMISA ELEMBO",
  CLEF: "LIFUNGÓLA",
  DIFFICULTY: "MPƐ́TƐ́",
  ACCIDENTALS: "LIYÉBISI",
  LANGUAGE: "LOKÓTÁ",
  twentySeconds: "20 s",
  oneMinute: "1 min",
  fiveMinutes: "5 min",
  infinite: "∞",
  buttons: "Mapúngu",
  piano: "Mángolá",
  trebleClef: "sol",
  bassClef: "bási",
  altoClef: "alto",
  tenorClef: "tenor",
  pianoClef: "Mángolá",
  easy: "mwa pɛ́tɛ́",
  normal: "mwa katikáti",
  hard: "mwa mpási",
  none: "mɔ̌kɔ́ tɛ̂",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ mpé ♭",
  SOUND: "LOKITO",
  DISPLAYCORRECTNOTE: "ZOBRAZIT SPRÁVNOU NOTU",
  on: "elamúísámí",
  off: "etendísámí",

  TIME: "NTÁNGO",
  CORRECT: "MALÁMU",
  ACCURACY: "POLÉLÉ",
  SCORE: "MONGÉTÉ",

  record: "Elónga",
  history: "History" // TODO: English placeholder, because I couldn't find a translation online.
};



// WEBPACK FOOTER //
// ./src/resources/ln.js